module.exports = __webpack_public_path__ + "static/media/avatar29.db9ccf95.png";